import { ResearchUnit } from '@/domain/research-unit/ResearchUnit';

export interface ResearchUnitDataset {
  key: string;
  text: string;
}

export const toResearchUnitDataset = (researchUnit: ResearchUnit): ResearchUnitDataset => ({
  key: `${researchUnit.id}`,
  text: `${researchUnit.acronym} - ${researchUnit.name}`,
});
